import config from "../config";
import browserHistory from "../helpers/browserHistory";
import { getActions, getTypes } from "../helpers/crudActions";
import HttpClient from "../helpers/httpclient";
import { getParameterByName } from "../helpers/util";

async function getCompanies(id, q, inactive, companyId) {
  const params = { params: {} };
  if (id) {
    params.params.user_id = id;
  }
  if (companyId) {
    params.params.selected_id = companyId;
  }
  if (q) {
    params.params.q = q;
  }
  if (!inactive) {
    params.params.status = "active";
  }
  return HttpClient.get(`${config.api}/companies/all`, params);
}

export function fetchCompaniesOptions(id, inactive, companyId) {
  const getOption = (c) => ({
    value: c.id,
    label: c.name + (c.active ? "" : " (INACTIVE)"),
    company: c,
  });
  const getOptions = (companies) => ({
    options: companies.objects.filter((c) => c.active || c.id === companyId).map(getOption),
  });
  return async (input) => {
    const r = await getCompanies(id, input, inactive, companyId);
    return getOptions(r.data);
  };
}

async function withFeesAdvisorCalcs(q) {
  const params = { params: {} };
  if (q) {
    params.params.q = q;
  }
  return HttpClient.get(`${config.api}/companies/with-fees-advisor-calcs`, params);
}

export function fetchCompaniesWithFeesAdvisorCalcsOptions() {
  const getOption = (c) => ({ value: c.id, label: c.name, company: c });
  const getOptions = (companies) => ({
    options: companies.objects.map(getOption),
  });
  return async (input) => {
    const r = await withFeesAdvisorCalcs(input);
    return getOptions(r.data);
  };
}

export default {
  ...getActions("COMPANIES", "companies"),
  ...getTypes("COMPANIES"),
  save(object, redirect = true) {
    return this.saveWithUpload(object, ["logo", "advisor_consulting_agreement_pdf"], redirect);
  },
  redirect(response) {
    if (getParameterByName("return") === "user") {
      const userId = getParameterByName("id");
      if (userId) {
        browserHistory.push(`/user/${userId}/edit?company=${response.data.id}`);
      } else {
        browserHistory.push(`/user/new?company=${response.data.id}`);
      }
    } else {
      const path = `/company/${response.data.id}/edit`;
      if (window.location.pathname !== path) {
        browserHistory.push(path);
      }
    }
    return response;
  },
};

export async function fetchUsers(id) {
  const r = await HttpClient.get(`${config.api}/companies/${id}/users`);
  return r.data;
}
